// Parses the OAuth `state` param for both IDP auth and FHIR (Cerner/Epic) flows.
// Accepts raw JSON or JWT-like tokens; returns key/value pairs merged into params.
export type AuthStateParams = Record<string, string>;

export function parseAuthState(state: string): AuthStateParams {
  try {
    return JSON.parse(state);
  } catch (jsonError) {
    const originalError =
      jsonError instanceof Error ? jsonError : new Error('Failed to parse state token');
    const [, payload] = state.split('.');
    if (!payload) throw originalError;

    try {
      const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = normalized.padEnd(
        normalized.length + ((4 - (normalized.length % 4)) % 4),
        '='
      );
      const decoded = atob(padded);
      return JSON.parse(decoded);
    } catch (err) {
      throw originalError;
    }
  }
}

export default function updateParamsWithIdpState(params: Record<string, string>) {
  if (!params || !params.state) return;

  try {
    const stateParams = parseAuthState(params.state);
    for (const [key, value] of Object.entries(stateParams)) {
      if (!(key in params)) params[key] = value;
    }
  } catch (err) {
    console.error('Failed to parse state query params for', params.state);
  }
}
